
TweenLite.set("h1", {visibility:"visible"});
TweenLite.set(".load-hidden", {visibility:"visible"});

const textReveal = new SplitType('h1', { types: 'lines' })
const textRevealh2 = new SplitType('h2', { types: 'lines' })
const textRevealh3 = new SplitType('h3', { types: 'lines' })

gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray('.sec').forEach((sec, i) => {
    let tl = gsap.timeline({
        stagger: 0,
        scrollTrigger: {
            trigger: sec,
            markers: false,
            start: 'top 75%',
            end: 'bottom bottom',
        }
    });
    tl.from(sec.querySelectorAll('.line'), {
        y:130,
        opacity: 0,
        stagger: 0.2,
        duration: 1,
        rotation:5,
        transformOrigin: "left bottom",
        ease: Power4.easeOut
    });
    tl.from(sec.querySelectorAll('.fade-in'), {
        opacity: 0,
        y: 50,
        delay:3,
        stagger: 0.15,
        duration: .3,
        ease: Power4.easeOut
    }, "-=4");
    tl.from(sec.querySelectorAll('.image-reveal'), {
        duration: .5,
        opacity: 0,
        delay:1,
        ease: Power4.easeOut
    }, "-=1.75");


});


const text = gsap.utils.toArray('.fade-in-inner p');
const quote = gsap.utils.toArray('.block-quote');
const line = gsap.utils.toArray('.case-info-line');
const image = gsap.utils.toArray('.fifty-fifty .section .image');
const singleImage = gsap.utils.toArray('.image-effect');

text.forEach((text, i) => {
    gsap.fromTo(
        text,
        { opacity: 0, y: 50,
            stagger: 0.15,
            duration: .3,
            ease: Power4.easeOut
        },
        {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: text,
                start: 'top 80%',
                end: 'top 20%',
                scrub: false,
                markers: false
            }
        }
    );
});

quote.forEach((text, i) => {
    gsap.fromTo(
        text,
        { opacity: 0, y: 50,
            stagger: 0.15,
            duration: .3,
            ease: Power4.easeOut
        },
        {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: text,
                start: 'top 80%',
                end: 'top 20%',
                scrub: false,
                markers: false
            }
        }
    );
});

line.forEach((text, i) => {
    gsap.fromTo(
        text,
        { opacity: 0, y: 50,
            stagger: 0.15,
            duration: .3,
            ease: Power4.easeOut
        },
        {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: text,
                start: 'top 80%',
                end: 'top 20%',
                scrub: false,
                markers: false
            }
        }
    );
});



image.forEach((text, i) => {
    gsap.fromTo(
        text,
        {   duration: .5,
            opacity: 0,
            delay:1,
            ease: Power4.easeOut
        },
        {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: text,
                start: 'top 80%',
                end: 'top 20%',
                scrub: false,
                markers: false
            }
        }
    );
});

singleImage.forEach((text, i) => {
    gsap.fromTo(
        text,
        {   duration: .5,
            opacity: 0,
            delay:1,
            ease: Power4.easeOut
        },
        {
            opacity: 1,
            y: 0,
            scrollTrigger: {
                trigger: text,
                start: 'top 80%',
                end: 'top 20%',
                scrub: false,
                markers: false
            }
        }
    );
});

